"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
require("./ToastProgress.css");
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
function ToastProgress(_a) {
    var label = _a.label, show = _a.show, percentage = _a.percentage;
    var wrapperClassName = classnames_1.default("nimbus--toast-progress-wrapper", {
        "is--visible": show,
    });
    var container = React.useMemo(function () { return document.createElement("div"); }, []);
    React.useEffect(function () {
        document.body.appendChild(container);
        return function () {
            document.body.removeChild(container);
        };
    }, [container]);
    var element = (React.createElement("div", { className: wrapperClassName },
        React.createElement("div", { className: "nimbus--toast-progress" },
            React.createElement(__1.Spinner, { appearance: "light" }),
            React.createElement(__1.Text, null, label),
            percentage && React.createElement(__1.Text, { bold: true },
                percentage,
                "%"))));
    return ReactDOM.createPortal(element, container);
}
exports.default = ToastProgress;
//# sourceMappingURL=index.js.map